import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { CustomerOrdersPage } from "src/components/views/erp/sales/customerOrder/CustomerOrdersPage.tsx";
import { useKeptAliveView } from "src/routing/keepAlive/keptAliveView.ts";

export const Route = createFileRoute("/_authenticated/_shell/sales/customerOrders")({
	staticData: { title: i18n.t("customer_orders"), legacyViewKey: "customerOrdersPage" },
	component: RouteComponent,
});

function RouteComponent() {
	const { isActive } = useKeptAliveView();
	return <CustomerOrdersPage isActive={isActive} />;
}
